stimulusApp.register(
  "guest-names",
  class extends Stimulus.Controller {
    static values = { maxNames: Number }
    static targets = ["addButton", "maxMessage", "fieldTemplate"]

    connect() {
      this.updateUI()
    }

    addName(e) {
      e.preventDefault()
      const currentCount = this.#getCurrentFieldCount()

      if (currentCount >= this.maxNamesValue) {
        return
      }

      const newIndex = this.#getNextAvailableIndex()
      const fieldContainer = this.#createFieldContainer(newIndex)

      this.addButtonTarget.before(fieldContainer)
      this.updateUI()
    }

    removeName(e) {
      e.preventDefault()
      const container = e.target.closest(".flex")
      if (container) {
        container.remove()
        this.updateUI()
      }
    }

    updateUI() {
      const currentCount = this.#getCurrentFieldCount()
      const maxReached = currentCount >= this.maxNamesValue

      if (maxReached) {
        this.addButtonTarget.classList.add("hidden")
        this.maxMessageTarget.classList.remove("hidden")
      } else {
        this.addButtonTarget.classList.remove("hidden")
        this.maxMessageTarget.classList.add("hidden")
      }
    }

    #getCurrentFieldCount() {
      return this.element.querySelectorAll('input[name="names[]"]').length
    }

    #createFieldContainer(index) {
      const template = this.fieldTemplateTarget.content.cloneNode(true)
      const input = template.querySelector("input")
      const label = template.querySelector("label")

      input.id = `names${index}`
      label.setAttribute("for", `names${index}`)

      return template
    }

    #getNextAvailableIndex() {
      const usedIndexes = new Set()
      const inputs = this.element.querySelectorAll('input[name="names[]"]')

      inputs.forEach((input) => {
        const match = input.id.match(/names(\d+)/)
        if (match) {
          usedIndexes.add(parseInt(match[1]))
        }
      })

      let index = 1
      while (usedIndexes.has(index)) {
        index++
      }
      return index
    }
  },
)
